module.exports = __webpack_public_path__ + "static/media/30OIOS10.b416398e.jpg";